import { Player } from "../../../types/SBCPlayer";
import axios from "../../privateApi";

export interface PlayerSwap extends Player {
  new_solution_info: {
    player_chems: number[];
    n_untradeables: number;
    n_owned_players: number;
    n_duplicates: number;
    rating: number;
    total_chem: number;
    price: number;
    transfer_market_cost: number;
  };
}

export const playerSwap = async ({
  id,
  untradeable,
  excludeActiveSquad,
  excludeObjectivePlayers,
  excludeSbcPlayers,
  includeTransferList,
  prioritizeDuplicates,
  prioritizeSbcStorage,
  playerIds,
  excludedPlayers,
  minRating,
  maxRating,
  playersFrom,
}: {
  id: number;
  untradeable: boolean;
  excludeActiveSquad: boolean;
  excludeObjectivePlayers: boolean;
  excludeSbcPlayers: boolean;
  includeTransferList: boolean;
  prioritizeDuplicates: boolean;
  prioritizeSbcStorage: boolean;
  playerIds: number[];
  excludedPlayers: number[];
  minRating: null | number;
  maxRating: null | number;
  playersFrom: "club" | "both" | "market";
}) => {
  const response = await axios.post<PlayerSwap[][]>("/player-swap", {
    id,
    untradeable,
    // The API still requires the rarity flags; the app no longer offers them.
    excludeGoldPlayers: false,
    excludeSilverPlayers: false,
    excludeBronzePlayers: false,
    excludeSpecialPlayers: false,
    excludeObjectivePlayers,
    excludeSbcPlayers,
    excludeActiveSquad,
    includeTransferList,
    prioritizeDuplicates,
    prioritizeSbcStorage,
    playerIds,
    excludedPlayers,
    minRating,
    maxRating,
    playersFrom,
  });
  if (response.data) {
    return response.data;
  }
  return [] as PlayerSwap[][];
};
